var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Button, Notice, Spinner, Table } from 'telia-front-react';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import customerIdAsKey from '../../auth/customerIdAsKey';
import { MandateQueryType, MandateType } from '../../config/mandate';
import { getValueOrDash } from '../../util/ParamsUtil';
import RepresentationRightsEditMandateModal from './RepresentationrightsEditMandateModal';
import RepresentationRightsMandateType from './RepresentationRightsMandateType';
import RepresentationRightsValidUntil from './RepresentationRightsValidUntil';
import { injectStores } from '../../util/StoresUtil';
let RepresentationRightsCustomerMandates = class RepresentationRightsCustomerMandates extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mandateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "editMandateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    componentDidMount() {
        this.mandateStore.fetchMandates(MandateQueryType.CUSTOMER_MANDATES);
        this.mandateStore.loadMandateInfo([MandateType.LEGAL], false);
    }
    render() {
        const { customer } = this.ssoStore;
        const { isFetching, getResultValue } = this.mandateStore;
        const customerMandates = getResultValue(MandateQueryType.CUSTOMER_MANDATES).filter((customerMandate) => customerMandate.isVisible(customer));
        if (isFetching(MandateQueryType.CUSTOMER_MANDATES)) {
            return React.createElement(Spinner, null);
        }
        return (React.createElement(Table, { responsive: "cols", break: "sm" },
            this.renderCustomerMandatesHeader(),
            customerMandates.length > 0 ? this.renderCustomerMandates(customerMandates) : this.renderNoCustomerMandatesNotice()));
    }
    renderCustomerMandatesHeader() {
        const { translate } = this.translateStore;
        return (React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("th", null, translate('personPowers.name')),
                React.createElement("th", null, translate('personPowers.registrationNumber')),
                React.createElement("th", null, translate('personPowers.mandateType')),
                React.createElement("th", null, translate('personPowers.validUntil')),
                React.createElement("th", null))));
    }
    renderCustomerMandates(customerMandates) {
        return React.createElement("tbody", null, this.buildCustomerMandateRowsForRendering(customerMandates));
    }
    renderNoCustomerMandatesNotice() {
        const { translate } = this.translateStore;
        return (React.createElement("tbody", null,
            React.createElement("tr", { style: { border: 'none' } },
                React.createElement("td", null,
                    React.createElement(Notice, { size: "small" }, translate('personPowers.NONE'))))));
    }
    buildCustomerMandateRowsForRendering(customerMandates) {
        return customerMandates.map((customerMandate, index) => this.buildCustomerMandateRowForRendering(customerMandate, index));
    }
    buildCustomerMandateRowForRendering(customerMandate, index) {
        const { translate } = this.translateStore;
        const { isManageCustomerMandateDisabled } = this.mandateStore;
        return (React.createElement("tr", { key: index },
            React.createElement("td", { className: "table__cell--2" },
                React.createElement("span", { className: "text-bold" }, getValueOrDash(`${customerMandate.firstName} ${customerMandate.lastName}`))),
            React.createElement("td", { className: "table__cell--1" }, customerMandate.personalCode),
            React.createElement("td", { className: "table__cell--2" },
                React.createElement(RepresentationRightsMandateType, { mandate: customerMandate, type: MandateQueryType.CUSTOMER_MANDATES })),
            React.createElement("td", { className: "table__cell--1" },
                React.createElement(RepresentationRightsValidUntil, { mandates: customerMandate.getVisibleMandates() })),
            React.createElement("td", { className: "table__cell--2" },
                React.createElement(Button, { text: translate('personPowers.mandate.edit'), iconLeft: "#edit", link: true, onClick: () => this.editMandateStore.openManageModal(customerMandate), disabled: isManageCustomerMandateDisabled(customerMandate) }),
                React.createElement(RepresentationRightsEditMandateModal, { isOpen: this.editMandateStore.isManageModalOpen.get(customerMandate.redisId), onClose: () => this.editMandateStore.closeManageModal(customerMandate) }))));
    }
};
RepresentationRightsCustomerMandates = __decorate([
    customerIdAsKey,
    injectStores,
    observer
], RepresentationRightsCustomerMandates);
export default RepresentationRightsCustomerMandates;
